import axios from 'axios';
import qs from 'query-string';
import { apiConfig } from '../api-config';

// eslint-disable-next-line no-shadow
export enum StatusInfoVoucher {
  available = 'Disponível',
  expired = 'Expirado',
  registered = 'Cadastrado',
  none = 'None',
  test = 'test'
}

export interface GetVoucherParams {
  tokenKey: string;
  cdUser: number;
  pageNumber: number;
  pageSize: number;
  status?: StatusInfoVoucher | null;
}

const validateStatus = (status: number) => (status >= 200 && status <= 300) || status === 404;

export const getAll = async (params: GetVoucherParams, cdUser: string, tokenKey: string, condition: string) => {
  const query = qs.stringify(params, { skipNull: true });

  const getAllVoucher = apiConfig.get(`api/Voucher/getAll-by-cdUser?${query}`, { validateStatus });
  const getByCdUser = apiConfig.get(`api/ShareVoucher/get-by-cdUser?${query}`, { validateStatus });
  const totalVoucher = apiConfig.get(`api/Voucher/getAll-by-cdUser-all?tokenKey=${tokenKey}&cdUser=${cdUser}&condition=${condition}`);
  return axios.all([getAllVoucher, getByCdUser, totalVoucher]).then(axios.spread((res1, res3, res4) => ({
    vouchers: res1.data || [],
    size: res4.data,
    total: res3.data.avaliable || 0,
    avaliable: res3.data.avaliable,
    used: res3.data.used,
  }))).catch((err) => ({ hasErrors: true, err: err.message }));
};
